import { TranslatePipe } from '@ngx-translate/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'session-calendar-agency-tabs',
    templateUrl: './agency.component.html',
    styleUrls: ['./agency.component.scss'],
    providers: [TranslatePipe],
})
export class SessionCalendarAgencyComponent implements OnInit {
    static ALL_AGENCIES_ID: number = -1;

    @Input()
    agencies: any = [];

    @Input()
    selectedAgencyId: number = null;

    @Output()
    selectedAgencyIdChange: EventEmitter<number> = new EventEmitter();

    ngOnInit(): void {}

    isSelectedAgency(agencyId) {
        return this.selectedAgencyId == agencyId;
    }

    isSelectedAllAgency() {
        return (
            this.selectedAgencyId ==
            SessionCalendarAgencyComponent.ALL_AGENCIES_ID
        );
    }

    selectAgency(agencyId: number) {
        this.selectedAgencyIdChange.emit(agencyId);
    }

    selectAllAgencies() {
        this.selectedAgencyIdChange.emit(
            SessionCalendarAgencyComponent.ALL_AGENCIES_ID
        );
    }

    colorStyle(agency): string {
        return agency ? agency.name : '';
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/calendar/agency/agency.component.ts